import * as React from "react";
import { cn } from "./cn";

const sizeMap = {
  sm: 14,
  md: 18,
  lg: 24,
  xl: 32,
} as const;

export type SpinnerProps = React.SVGAttributes<SVGSVGElement> & {
  size?: keyof typeof sizeMap;
  label?: string;
};

export function Spinner({
  size = "md",
  className,
  label = "Đang tải",
  ...props
}: SpinnerProps) {
  const px = sizeMap[size];
  return (
    <svg
      role="status"
      aria-label={label}
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("animate-spin", className)}
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="3"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
